import * as React from 'react';
// mui
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
// axios
import api from '../../axios';

export default function FeedbackPage() {
  const [ textContent, setTextContent ] = React.useState<string>('');
  const [ isLoading, setIsLoading ] = React.useState<boolean>(false);
  const [ showErrorBar, setShowErrorBar ] = React.useState<boolean>(false);
  const [ showSuccessBar, setShowSuccessBar ] = React.useState<boolean>(false);

  const handleFeedbackSubmission = () => {
    setIsLoading(true);
    api.post('/feedback', {
        content: textContent
      })
      .then((res) => {
        console.log(res);
        setShowSuccessBar(true);
        setTextContent('');
      })
      .catch((err) => {
        console.log(err);
        setShowErrorBar(true);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      minHeight="calc(100vh - 112px)"
    >
      <Card sx={{ width: '100%', m: 0, p: 2 }} variant="outlined">
        <CardHeader 
          title="Feedback"
          subheader="Please Let Us Know if You Have any Ideas or Suggestions"
        />
        <Divider />
        <CardContent>
          <TextField
            label="Feedback"
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            sx={{ paddingBottom: 2 }}
            multiline
            rows={6}
            fullWidth
          />
          <Button
            fullWidth
            variant='contained'
            loading={isLoading}
            onClick={handleFeedbackSubmission}
          >
            Submit
          </Button>
          <Typography sx={{ mt: 2}} variant="body2">By sending us feedback we are able to focus our efforts on what matters most, the needs of the user. If you have any ideas for ways the app can be improved, or even completely new ideas that could make the app even better, please let us know! We appreciate your feedback!</Typography>
        </CardContent>
      </Card>

      <Snackbar
        open={showErrorBar}
        autoHideDuration={6000}
        onClose={() => { setShowErrorBar(false); }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          There was an error submitting the feedback. You probably dont have internet!
        </Alert>
      </Snackbar>

      <Snackbar
        open={showSuccessBar}
        autoHideDuration={6000}
        onClose={() => { setShowSuccessBar(false); }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Thank you for your submission, we look over every feedback submission!
        </Alert>
      </Snackbar>
    </Box>
  );
}
